/**
 * Baacal HOTFIX 2026-07-17 / updated 2026-07-19
 * Why: Klaviyo Save Your Cart + signup flyouts mount fixed wrappers above the
 * cart drawer, so Checkout taps hit the popup. Theme cannot change Klaviyo
 * targeting alone.
 * How: while cart drawer is open or on /cart, hide those overlays (and Enzuzo
 * cookie banner). Also hide 45s signup (Xk4zw5) when cart has items OR
 * Klaviyo profile is identified (html[data-baacal-klaviyo-identified]).
 */
(function () {
  var SELECTORS = [
    '[data-testid="FLYOUT"]',
    '[data-testid="klaviyo-form-SHTXDu"]',
    '[data-testid="klaviyo-form-WFESXS"]',
    '[data-testid="klaviyo-form-YuXtzd"]',
    '[data-testid="klaviyo-form-Xk4zw5"]',
    '.kl-teaser-YuXtzd',
    '.kl-teaser-Xk4zw5',
    '#ez-cookie-notification',
    '.enzuzo-cookiebanner-container',
  ];

  function shouldSuppressCheckoutOverlays() {
    var body = document.body;
    if (!body) return false;
    if (body.classList.contains('js-drawer-open-cart')) return true;
    if (body.classList.contains('template-cart')) return true;
    return false;
  }

  function cartHasItems() {
    return document.documentElement.getAttribute('data-baacal-cart-has-items') === '1';
  }

  function klaviyoIdentified() {
    return document.documentElement.getAttribute('data-baacal-klaviyo-identified') === '1';
  }

  function hideEl(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('opacity', '0', 'important');
  }

  function hideWithParents(el) {
    hideEl(el);
    var node = el.parentElement;
    for (var i = 0; i < 6 && node && node !== document.body; i++) {
      var pos = window.getComputedStyle(node).position;
      var z = parseInt(window.getComputedStyle(node).zIndex, 10) || 0;
      if (pos === 'fixed' && z >= 1000) hideEl(node);
      node = node.parentElement;
    }
  }

  function suppress() {
    if (shouldSuppressCheckoutOverlays()) {
      var drawer = document.querySelector('.cart-drawer');
      if (drawer) drawer.style.setProperty('z-index', '100050', 'important');

      SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(hideWithParents);
      });

      document.querySelectorAll('div.needsclick').forEach(function (el) {
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        var z = parseInt(cs.zIndex, 10) || 0;
        if (z < 1000) return;
        if (
          el.querySelector(
            '[data-testid="FLYOUT"], [data-testid="klaviyo-form-SHTXDu"], [data-testid="klaviyo-form-WFESXS"], [data-testid="klaviyo-form-YuXtzd"], [data-testid="klaviyo-form-Xk4zw5"], .klaviyo-form'
          )
        ) {
          hideEl(el);
        }
      });
    }

    // Never show interruptive signup while cart has items OR profile is identified
    if (cartHasItems() || klaviyoIdentified()) {
      document
        .querySelectorAll(
          '[data-testid="klaviyo-form-Xk4zw5"], .kl-teaser-Xk4zw5, .klaviyo-form-Xk4zw5'
        )
        .forEach(hideWithParents);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      suppress();
    });
  }

  function boot() {
    suppress();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    new MutationObserver(schedule).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-baacal-cart-has-items', 'data-baacal-klaviyo-identified'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
